import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import PieChart from 'react-minimal-pie-chart';
import loader from '../asset/img/loader.gif';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';

export default class Participation extends Component{
	constructor(props){
		super(props);
		this.state = {data:[],value_data:[],width:0,year:'',totalParticipation:'',totalRecipient:'',totalThankyous:'',loading:false,modalIsOpen:false,participation:true};
		this.updateDimensions = this.updateDimensions.bind(this);
		this.getStats = this.getStats.bind(this);
		this.getData = this.getData.bind(this);
		this.getValueCount = this.getValueCount.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	updateDimensions(){   
	    let updateWidth  = document.getElementById("chart").offsetWidth;
	    this.setState({ width: updateWidth });
	}
	openModal() {
    	this.setState({modalIsOpen: true});
  }
	closeModal() {
	    this.setState({modalIsOpen: false});
	}
	loadingFunc(loading){
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false},function(){
				this.closeModal();
			});
		}
	}

	getStats(){
		axios({
  		method:'post',
  		url:path,headers:{'Content-Type':'application/json'},
  		data:{endpoint:'info',table:'thankyous',action:'participation'}
  	}).then((response)=>{
  		let data = response.data.data;
  		let sender = (data[0].sender/data[0].user_count)*100;
  		let recipient = (data[0].receiver/data[0].user_count)*100;
  		this.setState({totalParticipation:sender,totalRecipient:recipient,totalThankyous:data[0].total,year:data[0].year});
  		this.getData(data[0].total);
  	});
	}

	getData(total){
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'thankyous',action:'department'}
		}).then((response)=>{
			let data = response.data.data;
			let departments = [];
			let percentage;
			data.forEach((dataSeg)=>{
				percentage = ((dataSeg.total/total)*100).toFixed(2);
				departments.push({title:dataSeg.department+" ("+percentage+"%)",value:dataSeg.total,label:dataSeg.department});
			});	
			this.setState({data:departments});
			this.loadingFunc(false);
		}).catch(e => console.log("getDATA", e));
	}

	getValueCount(){
		axios({
			method:'post',
			url:path,
			data:{endpoint:'info',table:'thankyous',action:'value_count'}
		}).then((response)=>{
			let value_data = [];
			let total = response.data.data[0].total;
			let percent;
			let valueLabel;
			let colorOptions = ["#FF6262","#B88AE6","#2EB8B8","#66C266","#E9967A","#747400","#B8008A","#6666ff"];
			response.data.data.forEach((values,i)=>{
				if(values.count !== 0){
					percent = ((values.count/total)*100).toFixed(2);
					value_data.push({label:values.virtue,title:values.virtue+" ("+percent+"%)",value:values.count,color:colorOptions[i]});
				}
			});
			this.setState({value_data:value_data});
		});
	}

	componentDidMount(){
  	this.loadingFunc(true);
  	this.getStats();
		this.updateDimensions();
		this.getValueCount();
	}
	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    maxWidth:'400px',
		    minWidth:'300px',
		    width:'100%',
		    borderStyle:'solid',
		    backgroundImage:'url('+sparkles2+')',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		let content;
		let participation = Number(this.state.totalParticipation).toFixed(2);
		let recipient = Number(this.state.totalRecipient).toFixed(2);
		let divStyle = {display: 'inline-block'}//,width:'100%',height:'100%'};
		if(this.props.active){
			divStyle = {display: 'inline-block',width:'100%',height:'100%',minWidth:'700px',maxWidth:'1020px'};
			const data_Meta= {
				"Accounting": {"color": '#0000CD', "parentDepartment":null},
				"ASM North": {"color": '#008080', "parentDepartment":"RSD"},
				"ASM South": {"color": '#F5FFFA', "parentDepartment":"RSD"},
				"ASM West": {"color": '#8FBC8F', "parentDepartment":"RSD"},
				"Atlanta DC": {"color": '#FF8C00', "parentDepartment":'Operations'},
				"B.U. Americas": {"color": '#FF3A3A', "parentDepartment":null},
				"Business Development": {"color": '#00FF00', "parentDepartment":'Miscellaneous'},
				"C.o.E": {"color": '#FFF8DC', "parentDepartment":'Miscellaneous'},
				"Chicago DC": {"color": '#9400D3', "parentDepartment":'Operations'},
				"CNC": {"color": '#F0E68C', "parentDepartment":'Operations'},
				"Customer Experience": {"color": '#E9967A', "parentDepartment":'Customer Experience'},
				"Dallas DC": {"color": '#808080', "parentDepartment":'Operations'},
				"Engineering": {"color": '#B0C4DE', "parentDepartment":'Engineering'},
				"EXCOM" : {"color": '#8D5D93', "parentDepartment":'EXCOM'},
				"Fabrication": {"color": '#B22222', "parentDepartment":'Operations'},
				"Human Resources": {"color": '#48D1CC', "parentDepartment":null},
				"Inside Sales": {"color": '#CD5C5C', "parentDepartment":'Customer Experience'},
				"Irvine DC": {"color": '#8B4513', "parentDepartment":'Operations'},
				"IT": {"color": '#8B0000', "parentDepartment":null},
				"Machine Department": {"color": '#FFA500', "parentDepartment":'Engineering'},
				"Miscellaneous": {"color": '#ed00a2', "parentDepartment":'Miscellaneous'},
				"MSM": {"color": '#87CEEB', "parentDepartment":'RSD'},
				"Operations": {"color": '#FF69B4', "parentDepartment":'Operations'},
				"Product Management": {"color": '#DEB887', "parentDepartment":'Product Management'},
				"Production": {"color": '#f442e2', "parentDepartment":'Operations'},
				"Production Planning": {"color": '#CD853F', "parentDepartment":'Operations'},
				"Project Execution" : {"color": '#8D5D93', "parentDepartment":'EXCOM'},
				"Quality Control": {"color": '#FDF5E6', "parentDepartment":'Operations'},
				"RSD": {"color": '#81EF91', "parentDepartment":'RSD'},
				"Sales": {"color": '#008000', "parentDepartment":null},
				"Sales Services": {"color": '#ADD8E6', "parentDepartment":'Product Management'},
				"SAP": {"color": '#FF0000', "parentDepartment":'Miscellaneous'},
				"Strategic Marketing": {"color": '#7CFC00', "parentDepartment":'Miscellaneous'},
				"Supply Chain": {"color": '#F0F8FF', "parentDepartment":'Operations'},
				"Tech Service": {"color": '#F4A460', "parentDepartment":'Customer Experience'},
				"Valve Assembly": {"color": '#2F4F4F', "parentDepartment":'Operations'},
				"Marine": {"color": '#660066', "parentDepartment":null}
			};
			let chartData = [];
			const orderChart = [];
			this.state.data.forEach((e,i)=>{
				const newData = e;
				console.log(e);
				newData['color'] = data_Meta[e.label].color;
				if(data_Meta[newData.label] === undefined){
					const missingEntryIndex = orderChart.indexOf(newData.label);
					if(missingEntryIndex !==-1){
						chartData[missingEntryIndex].value += newData.value;
					}else{
						orderChart.push(newData.label);
						chartData.push(newData);
					}
				}else{
					if(data_Meta[newData.label].parentDepartment === null){
						orderChart.push(newData.label);
						chartData.push(newData);
					}else{
						const parentDepartmentIndex = orderChart.indexOf(data_Meta[newData.label].parentDepartment);
						if(parentDepartmentIndex!==-1){
							const departmentCount = chartData[parentDepartmentIndex].value;
							chartData[parentDepartmentIndex].value += newData.value;
						}else{
							const parentDepartment = data_Meta[newData.label].parentDepartment;
							orderChart.push(parentDepartment);
							chartData.push({title:parentDepartment,value:newData.value,color:data_Meta[parentDepartment].color,label:parentDepartment});
						}
					}
				}
			});
			let config = [];
			let legend;
			chartData = chartData.filter((item)=>{return item.value!==0});
			chartData.forEach((item)=>{
				let percentage = ((item.value/this.state.totalThankyous)*100).toFixed(2);
				config.push({color:item.color});
				if(item.title.indexOf("(") === -1){
					item.title = item.title+" ("+percentage+"%)";
				}
			});
			let chartContent;
			let buttonTabOneStyle = "ba b blueButton br3 br--left bg-white dark-blue bw1 b--dark-blue";
			let buttonTabTwoStyle = "ba b blueButton br3 br--right bg-white dark-blue bw1 b--dark-blue";
			const defaultLabelStyle = {
			  fontSize: '4px',
			  fontFamily: 'sans-serif',
			  fontWeight: 'bold'
			};
			if(this.state.participation){
				buttonTabOneStyle = "blueButton ba b br3 br--left bg-dark-blue white bw1 b--dark-blue";
				chartContent = <div>
												<h3 className="tc mt0">Total Participation for {this.state.year}: <span className="red">{participation}</span>% (Sender) <span className='red'>{recipient}</span>% (Recipient) <span className='red'>{this.state.totalThankyous}</span> (Total Thank yous)</h3>
										    	<div className='fl w-100 cf'>
												    {legend}
												   	<div className='fl w-100 tc cf chart-container'>
												    	{/* <PieChart
													      	data={chartData}
													      	style={{height:'400px',marginTop:'25px'}}
													      	paddingAngle={2}
													      	label={<CustomLabel />}
													      	labelStyle={defaultLabelStyle}
													      	labelPosition={105}
													      	lineWidth={99.5}
													        /> */}
														<PieCanvas
															data={ chartData }
														/>
													</div>
												
													
												</div>
											</div>;
			}else{
				buttonTabTwoStyle = "blueButton ba b br3 br--right bg-dark-blue white bw1 b--dark-blue";
				chartContent = <div>
										    	<div className='fl w-100 cf'>
												    {legend}
												   	<div className='fl w-100 tc cf chart-container'>
												    	{/* <PieChart
													      	data={this.state.value_data}
													      	style={{height:'400px',marginTop:'50px'}}
													      	label={<CustomLabel />}
													      	paddingAngle={1}
													      	labelStyle={defaultLabelStyle}
													      	labelPosition={105}
													      	lineWidth={99.5}
													    /> */}
														<PieCanvas
															data={ this.state.value_data }
														/>
													</div>
												
													<div className='fl w-25 cf absolute'  style={{maxWidth:'385px'}}>
														<b>{this.state.dataDisplay?this.state.dataDisplay:''}</b>
													</div>
												</div>
											</div>;
			}
			content = <div className='fl w-100 cf'>
							<div className="tc pb4">
								<button className={buttonTabOneStyle} id="buttonTabOne" onClick={()=>{this.setState({participation:true})}}>Departments</button>
								<button className={buttonTabTwoStyle} id="buttonTabTwo" onClick={()=>{this.setState({participation:false})}}>Values</button>
							</div>
							{chartContent}
					    <div>
							<Modal
					          isOpen={this.state.modalIsOpen}
					          style={customStyles}
					          contentLabel="loading"
					          shouldCloseOnOverlayClick={false}
					          shouldCloseOnEsc={false}
					        >
					        <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>
					        </Modal>
							</div>
					</div>
		}
		return(
				<div style={divStyle} id="chart">
					{content}
				</div>
		);
	}
}

const CustomLabel = props =>{ //need to figure out padding and actual background color
	
	let textDY = props.dy;
	if(navigator.userAgent.indexOf('MSIE') > -1 || navigator.appVersion.indexOf('Trident/') > -1){
  		textDY += 1;
	}
	let theid = "text_"+props.dataIndex;
	let thehref = "#"+theid;
	let circleX = props.x + props.dx;
	let circleY = props.y + props.dy;
	circleY = circleY < 0 ? circleY + 0.4 : circleY - 0.4;
	let textDX = props.dx > 0 ? props.dx+3 : props.dx - 3;
	return(
		<g>
			<circle cx={circleX} cy={circleY} r="2" fill={props.color} />
			<text id={theid} textAnchor={props.textAnchor} alignmentBaseline="middle" fill="black" x={props.x} y={props.y} dx={textDX} dy={textDY} style={props.style}>
				{props.data[props.dataIndex].label+" ("+props.data[props.dataIndex].value+")"}
			</text>
		</g>
	);
};

class PieCanvas extends Component{
	constructor(props){
		super(props);
		this.canvas = React.createRef();
		this.ctx = null;
		this.state = {
			dataLoaded: false
		};
	}

	componentDidMount(){
		this.ctx = this.canvas.current.getContext("2d");
		if( this.props.data.length !== 0 ){
			this.setState({ dataLoaded: true });
			this.drawChart();
		}
	}

	componentDidUpdate(prevProps){
		if( this.state.dataLoaded === false && this.props.data.length !== 0 && this.props.data !== prevProps.data ){
			this.setState({ dataLoaded: true });
			this.drawChart();
		}
	}

	drawChart(){
		let total = 0;
		const newData = [];

		this.props.data.forEach(data => {
			total += data.value;
			newData.push(
				{ ...data, percent: 0.00 }
			);
		});

		newData.sort((a, b) => b.value - a.value);
		for( let i = 0, j = newData.length - 1; i < j && j > i; i++, j--){

			if( i % 2 !== 0 ){
				let temp = newData[i];
				newData[i] = newData[j];
				newData[j] = temp;
			}
			
		}
		console.log(newData);
		const center_x = this.canvas.current.width / 2;
		const center_y = this.canvas.current.height / 2;
		const radius = ( this.canvas.current.height / 2 ) - 30;
		let percent, endPoint = 0, startingPoint = 0, medianPoint, offset_x, offset_y, x, y, xIsGreaterThan;

		newData.forEach(data => {
			percent = ( data.value / total );
			data.percent = percent * 100;
			startingPoint = endPoint;
			endPoint = endPoint + ( percent * Math.PI * 2 );
			medianPoint = (startingPoint + endPoint) / 2;
			data['midArcCoords'] = {_x: center_x + Math.cos(medianPoint) * radius, _y: center_y + Math.sin(medianPoint) * radius};
			this.ctx.beginPath();
			this.ctx.fillStyle = data.color;
			this.ctx.moveTo( center_x, center_y );
			this.ctx.strokeStyle = "#555555";
			this.ctx.arc( center_x, center_y, radius, startingPoint, endPoint );
			this.ctx.fill();
			this.ctx.lineTo(center_x, center_y);
			this.ctx.lineWidth = 0.5;
			this.ctx.strokeStyle = "#f4f4f4";
			this.ctx.stroke();
			this.ctx.beginPath();
			this.ctx.lineWidth = 1;
			this.ctx.strokeStyle = "#000000";
			this.ctx.moveTo(data.midArcCoords._x, data.midArcCoords._y);
			offset_y = data.midArcCoords._y + Math.sin(medianPoint) * 20;
			this.ctx.lineTo(data.midArcCoords._x + Math.cos(medianPoint) * 20, offset_y);
			this.ctx.stroke();
			xIsGreaterThan = ( data.midArcCoords._x > center_x );
			offset_x = xIsGreaterThan ? data.midArcCoords._x + 40 : data.midArcCoords._x - 40;
			this.ctx.lineTo( offset_x, offset_y );
			this.ctx.stroke();
			this.ctx.font = "bold 16px Arial";
			this.ctx.textAlign = xIsGreaterThan ? "left" : "end";
			//this.ctx.fillStyle = "#000000";
			this.ctx.fillText(data.label + " (" + data.value + ")", ( xIsGreaterThan ? offset_x + 5 : offset_x - 5 ), offset_y);
		});

		console.log(newData);

	}

	render(){
		//console.log(this.props.data);
		return <canvas ref={ this.canvas } height="460" width="1000"></canvas>;
	}
}


// WEBPACK FOOTER //
// ./src/container/Participation.js